import PropTypes from 'prop-types';
import { extendObservable, action, reaction, toJS } from 'mobx';
import { apiCall } from '../../../API';
import { RULE_REC_TYPE } from '../../../constants';
import ConcurrencyPopUpStore from '../../ConcurrencyPopUpStore';
import FlagStore from '../../FlagStore';
import FuseSearchTextStore from '../../FuseSearchTextStore';
import InputStore from '../../InputStore';
import UrlBulkEditorCardStore from '../../UrlBulkEditorCardStore';
import PolicyTableStore from '../PolicyTableStore';
import { ModalMode } from '../PolicyModalStore';
import { arrayDiff } from '../../../diff';

export default class CustomCategoriesStore {
    static PATH = '/console/custom-categories';
    static PUBLIC_PATH = '/api/v3/custom-categories';

    static PropType = PropTypes.shape({
        policyTable: PolicyTableStore.PropType.isRequired,
        aboutExpanded: FlagStore.PropType.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class CustomCategoriesStore */{
            policyTable: new PolicyTableStore({
                apiList: apiCall(CustomCategoriesStore.PATH + '/list'),
                // -----
                modalSections: {
                    urlList: {
                        dataPrefix: 'categoryIpAndUrlPatterns',
                        store: new UrlBulkEditorCardStore({
                            isValid: () => {
                                const st = this.policyTable.policyModal.sections.urlList.store;
                                return st.urlBulkEditorStore.bulkEditorStore.isValid() && st.getValue().length > 0;
                            },
                        }),
                        readOnlySearch: new FuseSearchTextStore(),
                        editConfirmAddedSearch: new InputStore(),
                        editConfirmRemovedSearch: new InputStore(),
                    },
                },
                requireEditConfirmation: () => {
                    if (!this.policyTable.policyModal.sections.urlList.store.hasChanged()) {
                        return false;
                    }
                    const oldItems = this.policyTable.policyModal.originalValue ?
                        this.policyTable.policyModal.originalValue.categoryIpAndUrlPatterns : [];
                    const newItems = this.policyTable.policyModal.sections.urlList.store.getValue();
                    const { added, removed } = arrayDiff(toJS(newItems), toJS(oldItems));
                    return (added && added.length > 0) || (removed && removed.length > 0);
                },
                noStatusField: true,
                concurrencyPopUpStore: new ConcurrencyPopUpStore({
                    apiVersionedUpdate: apiCall(`${CustomCategoriesStore.PATH}/versioned/update`),
                    apiUpdate: apiCall(`${CustomCategoriesStore.PATH}/update`),
                    apiCreate: apiCall(`${CustomCategoriesStore.PATH}/create`),
                    apiVersionedDelete: apiCall(`${CustomCategoriesStore.PATH}/versioned/delete`),
                    apiDelete: ({ id }) => apiCall(`${CustomCategoriesStore.PATH}/delete/${id}`)(),
                    type: RULE_REC_TYPE.CUSTOM_CATEGORIES,
                }),
            }),
            aboutExpanded: new FlagStore(true),
        }, data);

        reaction(() => this.policyTable.policyModal.mode, (newValue) => {
            if (newValue === ModalMode.EDIT || newValue === ModalMode.EDIT_CONFIRM) {
                this.resetConfirmSearchInputs();
            }
        });
    }

    resetConfirmSearchInputs = action(() => {
        this.policyTable.policyModal.sections.urlList.editConfirmAddedSearch.reset();
        this.policyTable.policyModal.sections.urlList.editConfirmRemovedSearch.reset();
    });
}
